import { render } from "./SummaryBox.vue?vue&type=template&id=a9dbca32&scoped=true"
import script from "./SummaryBox.vue?vue&type=script&lang=js"
export * from "./SummaryBox.vue?vue&type=script&lang=js"

import "./SummaryBox.vue?vue&type=style&index=0&id=a9dbca32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9dbca32"]])

export default __exports__